module.exports = __webpack_public_path__ + "media/images/black-back-c347c267ed05b2338eba9160a32c30f7.png";